/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

export function displayRole(str) {
  const role = str.split(/(?=[A-Z])/);

  for (let i = 0; i < role.length; i++) {
    if (role[i]) {
      // Update the first character to uppercase
      role[i] = role[i][0].toUpperCase() + role[i].slice(1);
    }
  }

  return role.join(' ');
}